import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { concatMap, forkJoin, Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';

import {
  DimensionModel,
  EntityAlertModel,
  EntityIconListPayloadModel,
  EntityListPayloadModel,
  EntityModel,
  RelationalEntityListModel,
  ResponseModelV2,
  ZonePlanEntityModel
} from 'src/app/model';
import { ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-relational-entity-list',
  templateUrl: './relational-entity-list.component.html',
  styleUrls: ['./relational-entity-list.component.scss']
})
export class RelationalEntityListComponent implements OnInit, OnDestroy {

  @Input()
  set content(value: ZonePlanEntityModel) {
    this._setEntityList(value);
  }

  @Input() dimension: DimensionModel;

  // Entity list
  relationalEntityList: RelationalEntityListModel[];

  // Subscription
  private _entitiesListSubscription: Subscription;

  // Miscellaneous
  readonly MESSAGES = Messages;

  constructor(
    private _service: ServicecallService
  ) { }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._entitiesListSubscription?.unsubscribe();
  }

  /**
   * Sets entity list
   * @param planEntity
   */
  private _setEntityList(planEntity: ZonePlanEntityModel) {
    let baseEntityList: EntityModel[];
    // Payload
    const payloadContent: Partial<EntityListPayloadModel> = {
      status: true,
      siteId: this._service.getSiteId(),
      type: planEntity?.type,
      entityIds: planEntity?.relationalEntity?.entityIds ?? []
    };
    this._entitiesListSubscription = this._service.entitiesList(payloadContent, null, false)
      .pipe(
        concatMap(
          (result: ResponseModelV2<EntityModel[]>) => {
            baseEntityList = result?.response?.data;
            const entityIdList = [...baseEntityList]?.map((entity) => entity?._id);
            // Icon list payload
            const payloadEntityIcon: Partial<EntityIconListPayloadModel> = {
              entityId: entityIdList
            };
            return forkJoin(
              [
                this._service.iconList(payloadEntityIcon)
              ]
            )
          }
        )
      )
      .subscribe({
        next: (result: [ResponseModelV2<EntityAlertModel[]>]) => {
          const [trackEntityAlertResult] = result;
          this.relationalEntityList = this._getRelationalEntityList(
            baseEntityList,
            trackEntityAlertResult?.response?.data
          );
        }
      });
  }

  /**
   * Gets relational entity list
   * @param entityList
   * @param trackEntityAlertList
   * @returns relational entity list
   */
  private _getRelationalEntityList(entityList: EntityModel[], trackEntityAlertList: EntityAlertModel[]): RelationalEntityListModel[] {
    return entityList
      ?.map(
        (entityContent: EntityModel) => {
          return {
            _id: entityContent?._id,
            name: entityContent?.name,
            uniqueId: entityContent?.uniqueId,
            category: entityContent?.category,
            alertsCount: trackEntityAlertList
              ?.find((trackEntityAlertContent) => trackEntityAlertContent?._id === entityContent?._id)
              ?.alertsCount 
              ?? 0
          } as RelationalEntityListModel;
        }
      );
  }
}
